import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// Shared markdown renderer used by the AI analysis pages. Styled to live
// comfortably on cream/white backgrounds alongside the rest of the editorial UI.
export default function AiMarkdown({ children }) {
  return (
    <div className="ai-markdown text-indie-ink leading-relaxed">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: (props) => <h1 className="text-2xl font-semibold text-indie-navy mt-6 mb-3 tracking-tight" {...props} />,
          h2: (props) => <h2 className="text-lg font-semibold text-indie-navy mt-6 mb-2 uppercase tracking-wider text-[13px] border-b border-indie-evergreen/30 pb-1" {...props} />,
          h3: (props) => <h3 className="text-base font-semibold text-indie-navy mt-5 mb-2" {...props} />,
          p: (props) => <p className="mb-3 text-[15px] leading-7 text-indie-ink/90" {...props} />,
          strong: (props) => <strong className="text-indie-navy font-semibold" {...props} />,
          ul: (props) => <ul className="list-disc pl-5 mb-3 space-y-1.5 text-[15px] leading-7 text-indie-ink/90" {...props} />,
          ol: (props) => <ol className="list-decimal pl-5 mb-3 space-y-1.5 text-[15px] leading-7 text-indie-ink/90" {...props} />,
          li: (props) => <li className="marker:text-indie-evergreen" {...props} />,
          table: (props) => (
            <div className="my-4 overflow-x-auto border-t-2 border-indie-navy">
              <table className="w-full text-sm num-tabular" {...props} />
            </div>
          ),
          thead: (props) => <thead className="bg-indie-navy text-indie-cream text-[11px] uppercase tracking-wider" {...props} />,
          th: (props) => <th className="text-left px-3 py-2 font-medium" {...props} />,
          td: (props) => <td className="px-3 py-2 border-t border-indie-navy/10 align-top" {...props} />,
          blockquote: (props) => <blockquote className="border-l-4 border-indie-evergreen pl-4 italic text-indie-ink/80 my-3" {...props} />,
          code: ({ inline, ...rest }) =>
            inline
              ? <code className="px-1 py-0.5 bg-indie-cream text-indie-cobalt text-xs font-mono" {...rest} />
              : <code className="block p-3 bg-indie-navy text-indie-cream text-xs font-mono overflow-x-auto" {...rest} />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
